import React, {Component, Fragment} from 'react';

import classNames from 'classnames';
import {generateId} from '../../shared/utils';
import i18n from '../../shared/i18n/i18n';
import FieldComponent from '../FieldComponent/FieldComponent';

export default class FieldRadio extends FieldComponent {

    constructor(props) {
        super(props);

        this.state.radio = this.props.option.radio;
    }

    render() {
        return (
            <div className="field-wrap">
                {this.props.option.label &&
                <label className="label">{i18n(this.props.option.label, this.props.setting.lang)}</label>
                }
                <div className={this.props.option.className ? this.props.option.className : "fb-col"}>
                    {this.state.enabledError &&
                    <div className={classNames(this.state.error.length === 0 && 'invisible', 'error')}>{i18n(this.state.error, this.props.setting.lang)}&nbsp;</div>
                    }
                    <div className="fb-row">
                        {this.state.radio.map(function (item) {
                            return (
                                <div className="fb-col m05rem ml-0" key={item.id}>
                                    <div className="fb-row fb-s-c">
                                        <input id={this.labelId + item.id} type="radio" value={item.value} disabled={!item.enabled} name={this.labelId} checked={this.state.value === item.value} onChange={e => this.onChange(e.currentTarget.value)}/>
                                        <label htmlFor={this.labelId + item.id} className="label">{i18n(item.label, this.props.setting.lang)}</label>
                                    </div>
                                    <div className="help">{i18n(this.props.option.help, this.props.setting.lang)}</div>
                                </div>
                            );
                        }, this)}
                    </div>
                </div>
            </div>
        );
    }

}